import { Typography } from '../../../components/Typography'
import { ReactComponent as Information } from '../../../assets/svg/Information.svg'
import moment from 'moment/moment'
import { timelineDateFormat } from '../../../components/Timelines/constants'
import { TNote } from '../types'
import { Avatar } from '../../../components/Avatar/Avatar'
import { useMemo } from 'react'
import { getCapitalCharName } from '../../../helper/common'
import { routes } from '../../../router'
import { Link } from '../../../components/Link'

export const Note = ({ note }: { note: TNote }) => {
  const noteWasUpdated = note?.updated_by && note?.updated_at

  const user = useMemo(() => {
    return noteWasUpdated ? note.updated_by : note.created_by
  }, [noteWasUpdated, note])
  return (
    <div className="column gap-16">
      <Typography.Body1>{note.text}</Typography.Body1>
      <div className="row gap-4 align-center mt-0">
        <Information className="note-info__date__icon" />
        <Typography.Caption className="note-info__date mr-8 nowrap">
          {`${noteWasUpdated ? 'Updated' : 'Added'} ${moment(
            noteWasUpdated ? note.updated_at : note.created_at
          ).format(timelineDateFormat)} by `}
        </Typography.Caption>
        {user && (
          <Link
            className="row gap-4 align-center"
            to={`${routes.createUserProfile}/${user.uuid}?fromCommunity=true`}
          >
            <Avatar
              name={getCapitalCharName(user.first_name, user.last_name)}
              alt="Responsible user image"
              src={user.avatar?.file_preview}
              size={24}
            />

            <Typography.Caption className="note-info__name">
              {`${user.first_name} ${user.last_name}`}
            </Typography.Caption>
          </Link>
        )}
      </div>
    </div>
  )
}
